<app-modal-layout
    *transloco="let tFieldTypeSelector; read: 'field_type_selector'"
    [containerLayout]="containerLayout"
    (closeModal)="forceWithValidation()"
>
    <ng-container title>{{ tFieldTypeSelector('add_fields') }}</ng-container>
    <ng-container subtitle>{{
        tFieldTypeSelector('add_fields_subtitle', { name: data.selectedWorkspace?.name?.value })
    }}</ng-container>
    <div class="overflow-hidden w-[49rem]">
        @if (fieldTypes$ | async; as fieldTypes) {
            <div>
                @if (fieldTypes.onePerWorkspace.length) {
                    <ng-container
                        [ngTemplateOutlet]="items"
                        [ngTemplateOutletContext]="{
                            fieldTypes: fieldTypes.onePerWorkspace,
                            onePerWorkspace: true,
                        }"
                    ></ng-container>
                    <app-tb-divider class="my-8 block"></app-tb-divider>
                }
                <ng-container
                    [ngTemplateOutlet]="items"
                    [ngTemplateOutletContext]="{
                        fieldTypes: fieldTypes.multiple,
                        onePerWorkspace: false,
                    }"
                ></ng-container>
            </div>
        }
    </div>
    <app-modal-layout-buttons buttons [action]="true">
        <app-tb-button
            action
            *transloco="let tButtons; read: 'buttons'"
            (click)="close()"
            appearance="text"
            icon="custom_arrow_back"
        >
            {{ tButtons('back') }}</app-tb-button
        >
    </app-modal-layout-buttons>
</app-modal-layout>
<ng-template
    #items
    [appTypedTemplate]="contextType"
    let-fieldTypes="fieldTypes"
    let-onePerWorkspace="onePerWorkspace"
>
    <div class="flex flex-wrap gap-4 mb-2 mt-5 px-2">
        @for (type of fieldTypes; track type.guid) {
            <div
                (click)="addField(type, onePerWorkspace)"
                class="flex flex-col items-center h-40 w-44 gap-2 py-5 px-4 rounded-2xl shadow-md cursor-pointer relative hover:shadow-button border-transparent border-2 hover:border-neutral3 group"
            >
                @if (!type.status) {
                    <span class="text-red-600 absolute top-0">DEV</span>
                }
                <app-tb-icon
                    [icon]="type.icon"
                    class="icon-xlg text-primaryLight"
                    [class]="onePerWorkspace ? 'text-primaryLight' : 'text-textLight'"
                ></app-tb-icon>
                <div *transloco="let tFieldTypeName; read: 'field_type.name'" class="subheading-2">
                    {{ tFieldTypeName(type.guid) }}
                </div>
                <div
                    *transloco="let tFieldTypeDescription; read: 'field_type.description'"
                    class="text-center caption-1 text-textLight group-hover:text-text"
                >
                    {{ tFieldTypeDescription(type.guid) }}
                </div>
            </div>
        }
    </div>
</ng-template>
